import script from "./AppView.vue?vue&type=script&setup=true&lang=js"
export * from "./AppView.vue?vue&type=script&setup=true&lang=js"

import "./AppView.vue?vue&type=style&index=0&id=53745ca5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53745ca5"]])

export default __exports__